import { useEffect, useState } from "react";
import { api } from "../api.js";
import type { LiveFightPayload } from "@mma/shared";

// Poll'er live endpoint hvert intervalMs. Returnerer nyeste payload + manuel refresh().
export function useLiveFight(intervalMs = 1500) {
  const [data, setData] = useState<LiveFightPayload | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;
    let timer: ReturnType<typeof setTimeout>;

    async function tick() {
      try {
        // vMix-kompatibelt format: API returnerer array; vi tager første row
        // (eller null hvis ingen kamp er live).
        const r = await api.get<LiveFightPayload[]>("/api/live");
        if (!cancelled) setData(r[0] ?? null);
      } catch (e) {
        if (!cancelled) setError(e as Error);
      } finally {
        if (!cancelled) timer = setTimeout(tick, intervalMs);
      }
    }
    tick();
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [intervalMs]);

  return { data, error };
}
